/**
 * Camlin Companion — persisted dismissal of the "Replies are spoken
 * aloud — tap the mic to talk." hint (Keith, round 3, 6 Aug 2026: the
 * caption "needs a close (×) and should stay dismissed").
 *
 * Same storage contract as `consent.ts` / `soundConsent.ts` so the
 * widget's injectable-storage test seam covers this module too.
 */

import type { CompanionConsentStorage } from './consent';

export const COMPANION_VOICE_HINT_STORAGE_KEY = 'camlin-companion-voice-hint-v1';

export function isCompanionVoiceHintDismissed(storage: CompanionConsentStorage): boolean {
  return storage.getItem(COMPANION_VOICE_HINT_STORAGE_KEY) === 'dismissed';
}

export function dismissCompanionVoiceHint(storage: CompanionConsentStorage): void {
  storage.setItem(COMPANION_VOICE_HINT_STORAGE_KEY, 'dismissed');
}
